import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  CartesianGrid,
} from "recharts";

interface OwnershipChartProps {
  data: Array<{ ownership: string; count: number }>;
}

const OWNERSHIP_COLORS: Record<string, string> = {
  public: "hsl(142 71% 45%)",
  private: "hsl(25 95% 53%)",
  institutional: "hsl(187 100% 33%)",
  unknown: "hsl(0 0% 70%)",
};

function titleCase(str: string): string {
  return str.replace(/\b\w/g, (c) => c.toUpperCase());
}

export function OwnershipChart({ data }: OwnershipChartProps) {
  if (!data.length) {
    return (
      <div className="flex h-[300px] items-center justify-center text-sm text-muted-foreground">
        No data yet
      </div>
    );
  }

  const formatted = data.map((d) => ({
    ...d,
    name: titleCase(d.ownership),
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={formatted} layout="vertical">
        <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
        <XAxis type="number" tick={{ fontSize: 12 }} />
        <YAxis
          type="category"
          dataKey="name"
          tick={{ fontSize: 12 }}
          width={80}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "hsl(var(--popover))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "6px",
            color: "hsl(var(--popover-foreground))",
          }}
        />
        <Bar dataKey="count" radius={[0, 4, 4, 0]}>
          {formatted.map((entry) => (
            <Cell
              key={entry.name}
              fill={
                OWNERSHIP_COLORS[entry.name.toLowerCase()] ??
                OWNERSHIP_COLORS.unknown
              }
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
